<template>

    <article class="cmp cmp-product-thumb cmp-product-thumb--grid" :data-testing="item.variation.id">
        <div class="thumb-inner" :class="paddingClasses" :style="paddingInlineStyles">
            <div>
                <div :class="item.variation.isMain ? 'isMain' : 'isNotMain'">
                    <add-to-basket
                        data-testing="item-add-to-basket"
                        :variation-id="item.variation.id"
                        :is-salable="!!item.filter && item.filter.isSalable"
                        :has-children="!!item.item && item.item.salableVariationCount > 1"
                        :interval-quantity="item.variation.intervalOrderQuantity || 1"
                        :minimum-quantity="item.variation.minimumOrderQuantity"
                        :maximum-quantity="!!item.variation.maximumOrderQuantity && item.variation.maximumOrderQuantity > 0 ? item.variation.maximumOrderQuantity : null"
                        :order-properties="item.properties.filter(function(prop) { return prop.property.isOderProperty })"
                        :has-order-properties="item.hasOrderProperties"
                        :use-large-scale="true"
                        :show-quantity="false"
                        :item-url="item | itemURL(urlWithVariationId)"
                        :has-price="item | hasItemDefaultPrice"
                        :item-type="item.item.itemType">
                    </add-to-basket>
                </div>
            </div>
            <div class="thumb-background"></div>
            <div class="thumb-image">
                <div class="square-container">
                    <div class="square-inner main-image">
                        <slot name="item-image">
                            <category-image-carousel :image-urls-data="item.images | itemImages(imageUrlAccessor)"
                                                     :alt="item | itemName"
                                                     :title="item | itemName"
                                                     :item-url="item | itemURL(urlWithVariationId)"
                                                     :enable-carousel="$ceres.config.item.enableImageCarousel"
                                                     :disable-carousel-on-mobile="disableCarouselOnMobile"
                                                     ref="categoryImageCarousel">
                            </category-image-carousel>
                        </slot>
                    </div>
                </div>
            </div>

            <!-- STORE SPECIALS -->
            <slot name="store-special">
                <item-store-special
                    v-if="storeSpecial || item.variation.bundleType === 'bundle' || item.item.itemType === 'set'"
                    :store-special="storeSpecial"
                    :recommended-retail-price="item.prices.rrp"
                    :variation-retail-price="item.prices.default"
                    :special-offer-price="item.prices.specialOffer"
                    :decimal-count="decimalCount"
                    :bundle-type="item.variation.bundleType"
                    :item-type="item.item.itemType">
                </item-store-special>
            </slot>
            <!-- ./STORE SPECIALS -->

            <!-- ITEM DETAILS -->
            <slot name="item-details text-center">
                <div @click="redirect()" class="item-details-wrapper">
                    <a :href="item | itemURL(urlWithVariationId)" class="thumb-content">
                        <span class="thumb-title">{{ item | itemName }}</span>
                    </a>
                    <div class="thumb-title small">
                        {{ item.texts.name2 }}
                    </div>
                    <div class="thumb-meta">
                        <slot name="before-prices"></slot>

                        <div class="prices">
                            <div
                                v-if="item.prices.rrp && item.prices.rrp.price.value > 0 && item.prices.rrp.price.value > item.prices.default.unitPrice.value"
                                class="price-view-port">
                                <del class="crossprice" v-if="item.prices.specialOffer">
                                    {{ item.prices.default.unitPrice.formatted | itemCrossPrice(true) }}
                                </del>
                                <del class="crossprice" v-else>
                                    {{ item.prices.rrp.unitPrice.formatted | itemCrossPrice }}
                                </del>
                            </div>

                            <div class="price">
                                <span v-if="!item.variation.isMain">
                                    ab
                                </span>
                                {{
                                    item.prices.default.unitPrice.formatted | specialOffer(item.prices, "unitPrice", "formatted")
                                }} *
                            </div>
                        </div>
                    </div>

                    <div class="btn btn-outline-primary mt-3 home-thumb-btn">
                        Details anzeigen
                    </div>

                    <slot name="after-prices"></slot>

                    <div class="category-unit-price"
                         v-if="!(item.unit.unitOfMeasurement === 'C62' && item.unit.content === 1)">
                        <span>{{ item.unit.content }}</span>
                        <span>&nbsp;{{ item.unit.names.name }}</span>
                        <span v-if="item.variation.mayShowUnitPrice">&nbsp;| {{ item.prices.default.basePrice }}</span>
                    </div>

                    <div>
                        <div :class="item.variation.isMain ? 'isMain' : 'isNotMain'">
                            <add-to-basket
                                :variation-id="item.variation.id"
                                :is-salable="!!item.filter && item.filter.isSalable"
                                :has-children="!!item.item && item.item.salableVariationCount > 1"
                                :interval-quantity="item.variation.intervalOrderQuantity || 1"
                                :minimum-quantity="item.variation.minimumOrderQuantity"
                                :maximum-quantity="!!item.variation.maximumOrderQuantity && item.variation.maximumOrderQuantity > 0 ? item.variation.maximumOrderQuantity : null"
                                :order-properties="item.properties.filter(function(prop) { return prop.property.isOderProperty })"
                                :has-order-properties="item.hasOrderProperties"
                                :use-large-scale="false"
                                :show-quantity="false"
                                :item-url="item | itemURL(urlWithVariationId)"
                                :has-price="item | hasItemDefaultPrice"
                                :item-type="item.item.itemType">
                            </add-to-basket>
                        </div>
                    </div>

                    <span class="availability-title small">Lieferzeit: </span>
                    <span :class="'availability small availability_' + item.variation.availability.id">
                        {{ item.variation.availability.names.name }}
                    </span>
                </div>
            </slot>
            <!-- ./ITEM DETAILS  -->
        </div>
    </article>
</template>

<script>
import {mapState} from "vuex";
import CategoryImageCarousel from "ceres/app/components/itemList/CategoryImageCarousel.vue";
import ItemStoreSpecial from "ceres/app/components/itemList/ItemStoreSpecial.vue";
import {isNullOrUndefined} from "ceres/app/helper/utils";

export default {
    components: {
        CategoryImageCarousel,
        ItemStoreSpecial
    },

    props: {
        decimalCount:
            {
                type: Number,
                default: 0
            },
        imageUrlAccessor:
            {
                type: String,
                default: "urlMiddle"
            },
        itemData:
            {
                type: Object
            },
        disableCarouselOnMobile:
            {
                type: Boolean
            },
        paddingClasses:
            {
                type: String,
                default: null
            },
        paddingInlineStyles:
            {
                type: String,
                default: null
            }
    },

    jsonDataFields: [
        "itemDataRef"
    ],

    methods: {
        redirect() {
            const enableOldUrlPattern = App.config.global.enableOldUrlPattern;
            const urlPath = this.item.texts.urlPath || "";
            const includeLanguage = !isNullOrUndefined(this.item.texts.lang) && App.defaultLanguage != this.item.texts.lang;

            let link = "";

            if (urlPath.charAt(0) !== "/") {
                link = "/";
            }

            if (includeLanguage) {
                link += this.item.texts.lang + "/";
            }

            if (urlPath && urlPath.length) {
                link += urlPath;
            }

            let suffix = "";

            if (enableOldUrlPattern) {
                suffix = "/a-" + this.item.item.id;
            } else if (this.urlWithVariationId) {
                suffix = "_" + this.item.item.id + "_" + this.item.variation.id;
            } else {
                suffix = "_" + this.item.item.id;
            }

            let trailingSlash = "";

            if (App.urlTrailingSlash) {
                trailingSlash = "/";
                if (link.length > 1 && link.charAt(link.length - 1) === "/") {
                    link = link.substr(0, link.length - 1);
                }
            }

            if (link.substr(link.length - suffix.length, suffix.length) === suffix) {
                return link + trailingSlash;
            }

            window.location.href = link + suffix + trailingSlash;
        }
    },

    computed:
        {
            item() {
                return this.itemData || this.itemDataRef;
            },

            /**
             * returns itemData.item.storeSpecial
             */
            storeSpecial() {
                return this.item.item.storeSpecial;
            },

            /**
             * returns itemData.texts
             */
            texts() {
                return this.item.texts;
            },

            itemPrice() {
                return this.$options.filters.specialOffer(this.item.prices.default.unitPrice.formatted, this.item.prices, "unitPrice", "formatted");
            },

            itemSetPrice() {
                return this.$options.filters.currency(
                    this.item.prices.default.price.value,
                    this.item.prices.default.currency
                );
            },

            urlWithVariationId() {
                return !this.$ceres.config.item.showPleaseSelect || this.$ceres.initialPleaseSelect == 0;
            },

            ...mapState({
                showNetPrices: state => state.basket.showNetPrices
            })
        }
}
</script>
